import React from 'react';
import { Box, Button, IconButton, Typography } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons';

type WorkItemsBulkActionBarProps = {
    selectedCount: number;
    onDone?: () => void;
    onSnooze?: () => void;
    onArchive: () => void;
    onClearSelection: () => void;
    archiveLabel?: string;
    archiveColor?: string;
};

const WorkItemsBulkActionBar: React.FC<WorkItemsBulkActionBarProps> = ({
    selectedCount,
    onDone,
    onSnooze,
    onArchive,
    onClearSelection,
    archiveLabel = 'Archive',
    archiveColor = 'var(--color-text-secondary)',
}) => {
    return (
        <Box
            sx={{
                position: 'fixed',
                bottom: 32,
                left: '50%',
                transform: 'translateX(-50%)',
                bgcolor: 'var(--color-bg-secondary)',
                borderRadius: 4,
                px: 3,
                py: 1.5,
                border: '1px solid var(--color-border)',
                display: 'flex',
                gap: 2,
                alignItems: 'center',
                boxShadow: '0 8px 32px rgba(0,0,0,0.2)',
                zIndex: 1300,
            }}
        >
            <Typography variant="body2" sx={{ color: 'var(--color-text-primary)', fontWeight: 'bold' }}>
                {selectedCount} selected
            </Typography>
            <Box sx={{ width: '1px', height: 20, bgcolor: 'var(--color-border)' }} />
            {onDone && <Button size="small" onClick={onDone} sx={{ color: '#4caf50' }}>Done</Button>}
            {onSnooze && <Button size="small" onClick={onSnooze} sx={{ color: '#ff9800' }}>Snooze</Button>}
            <Button size="small" onClick={onArchive} sx={{ color: archiveColor }}>{archiveLabel}</Button>
            <IconButton size="small" onClick={onClearSelection} sx={{ color: 'var(--color-text-primary)', ml: 1 }}>
                <FontAwesomeIcon icon={faTimesCircle} />
            </IconButton>
        </Box>
    );
};

export default WorkItemsBulkActionBar;
